<template>
  <main id="main">
    <div class="container">
      <header class="header">
        <a href="https://www.cna.com.br">
          <div class="logo">
            <img
              src="https://www.cna.com.br/wp-content/uploads/2024/08/logo-cna-idiomas-color.webp"
              alt="Logo CNA"
            />
          </div>
        </a>
      </header>
      <section id="cadastro" class="row">
        <div class="col-12">
          <span class="title text-center">Ops! Não foi possível encontrar a página solicitada.</span>
          <span
            class="subtitle text-center"
          >Verifique o endereço informado ou leia o QR Code novamente.</span>
        </div>
      </section>
    </div>
  </main>
</template>

<script>

export default {
  name: 'NotFound'
}

</script>

<style scoped lang="scss">
.subtitle {
  color: #484848;
  font-size: 18px;
  letter-spacing: 2px;
  font-weight: 500;
  display: block;
  margin: 0;
  padding: 0;
}

.title {
  color: #484848;
  font-size: 40px;
  line-height: 52px;
  font-weight: 700;
  display: block;
  margin: 0 0 30px;
  padding: 0;
}

#main {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-variant-numeric: lining-nums;

  .header {
    position: relative;
    z-index: 9;
    height: 170px;

    .logo {
      width: 218px;
      height: 218px;
      border-radius: 50%;
      display: inline-block;
      vertical-align: top;
      background: #fff;
      filter: drop-shadow(0px 3px 6px rgba(23, 23, 23, 0.25));
      margin: 0 0 0 -109px;
      text-decoration: none;
      position: absolute;
      left: 50%;
      //top: -90px;
      z-index: 999;
      transition: top 0.3s ease;

      img {
        display: block;
        height: 61px;
        width: 151px;
        margin: 104px auto 0;
        transition: all 0.3s ease;
      }
    }
  }
}
</style>